import { useDispatch, useSelector } from 'react-redux';
import { Box, useToast } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import { clearToast } from './resources/actions';

export const Toaster = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const { message, type } = useSelector((state: any) => state.toastReducer);
  const toastRef = useRef<number | string | null>(null);

  useEffect(() => {
    if (message) {
      // If a loading toast is currently displayed and a new success or error toast is dispatched,
      // close the loading toast.
      if (toastRef.current && type !== 'loading') {
        toast.close(toastRef.current);
      }

      toastRef.current = toast({
        position: 'bottom-right',
        title: message,
        status: type,
        duration: type === 'loading' ? null : 3000,
        variant: 'left-accent',
        size: '',
        isClosable: true,
        containerStyle: {
          width: '400px',
        },
      });

      if (type !== 'loading') {
        dispatch(clearToast());
      }
    }
  }, [message, type, toast, dispatch]);

  return (
    type === 'loading' && (
      <Box
        position="fixed"
        top="0"
        right="0"
        bottom="0"
        left="0"
        bg="rgba(255, 255, 255, 0.534)"
        zIndex="modal"
        style={{ backdropFilter: 'blur(2px)' }}
        onClick={(e) => e.stopPropagation()}
      />
    )
  );
};